import React, { useState, useEffect } from "react";
import ProductForm from "../Forms/ProductForm";

import SuccessPoP from "../SuccessFullPopUp/SuccessPoP";
import {
  DeleteProductImageApi,
  EditProductApi,
  FetchProductByIdApi,
} from "../../ApiCalls/AddProducts";
import { useParams } from "react-router-dom";

const EditProduct = ({ refetchProducts }) => {
  const { id } = useParams();
  const [productData, setProductData] = useState({
    name: "",
    description: "",
    actual_price: "",
    category: "",
    subcategory: "",
    stock: "",
    offer_percent: "0",
    min_order_quantity: "",
    min_order_quantity_two: "",
    min_order_quantity_three: "",
    min_order_quantity_four: "",
    min_order_quantity_five: "",
    delivery_charge: "",
    brand: "",
    product_images: [],
  });

  const [popup, setPopup] = useState({
    visible: false,
    success: false,
    button: false,
    message: "",
    subMessage: "",
  });

  useEffect(() => {
    const fetchProductData = async () => {
      try {
        const response = await FetchProductByIdApi({ id });
        setProductData(response.Data[0]);
        console.log("product data", response);
      } catch (error) {
        console.error("Error fetching product data:", error);
      }
    };

    if (id) fetchProductData();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setProductData((prevData) => ({
      ...prevData,
      product_images: [...prevData.product_images, ...files],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.keys(productData).forEach((key) => {
      if (key !== "product_images" && key !== "brand_logo") {
        formData.append(key, productData[key]);
      }
    });

    productData.product_images.forEach((image) => {
      formData.append("images", image);
    });

    try {
      console.log("dataaa",formData);
      
      await EditProductApi(id, formData);
      setPopup({
        visible: true,
        success: true,
        button: true,
        message: "Product Updated Successfully!",
        subMessage: "Your product details have been updated.",
      });

      if (refetchProducts) await refetchProducts();
    } catch (error) {
      console.error("Error updating product:", error);
      setPopup({
        visible: true,
        success: false,
        button: false,
        message: "Error Updating Product!",
        subMessage:
          "There was an issue updating your product. Please try again.",
      });
    }
  };

  const handleRemoveImage = async (index, productId, imageId) => {
    try {
      // Call the API to remove the image from the server
      await DeleteProductImageApi(productId, imageId); // Assuming you have this API call
      setProductData((prevData) => ({
        ...prevData,
        product_images: prevData.product_images.filter((_, i) => i !== index),
      }));
    } catch (error) {
      console.error("Error removing image:", error);
    }
  };

  return (
    <div className="h-full w-full p-2">
      <h1 className="mb-2 text-center text-2xl font-bold text-green-600">
        Edit Product
      </h1>
      <ProductForm
        productData={productData}
        handleChange={handleChange}
        handleImageChange={handleImageChange}
        handleRemoveImage={handleRemoveImage}
        handleSubmit={handleSubmit}
      />
      {popup.visible && (
        // <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform bg-white shadow-md w-fit h-fit rounded-lg">
        <div className="fixed inset-0 flex h-full w-full items-center justify-center bg-black bg-opacity-50">
          <SuccessPoP
            message={popup.message}
            status={popup.success}
            button={popup.button}
            subMessage={popup.subMessage}
            buttonText="View Products"
            onClose={() => setPopup({ visible: false, success: false })}
            redirectPath="/seller/products/view_products"
          />
        </div>
      )}
    </div>
  );
};

export default EditProduct;
